import { useContext, useEffect, useState } from "react";
import { useGetTransferAssets } from "src/services/link/queries/transfers";

import ThemeContext from "../../context";
import Context from "../context";

export const usePendingStatus = () => {
	const { state: themeState, actions } = useContext(ThemeContext);
	const { state } = useContext(Context);

	const { data, refetch, isError } = useGetTransferAssets(
		themeState.authToken,
		state.connectionToken
	);

	const [status, setStatus] = useState("PENDING");

	useEffect(() => {
		let intervalId: any;

		if (status === "PENDING" && !isError) {
			// Refetch the data at regular intervals when status is PENDING and there's no error
			intervalId = setInterval(() => {
				refetch();
			}, 1000);
		}

		// Cleanup interval on component unmount or when status changes
		return () => clearInterval(intervalId);
	}, [status, refetch, isError]);

	useEffect(() => {
		if (isError) {
			setStatus("ERRORED");
		} else if (data?.status) {
			setStatus(data.status);
		}
	}, [data, isError]);

	useEffect(() => {
		if (status === "READY" && data) {
			actions.setStep(4);
		}
	}, [status, data, actions]);

	return { status };
};
